import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import { Download } from "@mui/icons-material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import * as React from "react";
import { functionURLService } from "../../Components/functionalurl";
import { post } from "../../services/index";
import { useEffect } from "react";
import { useState } from "react";
import * as FileSaver from "file-saver";
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
const base = "https://";

export default function SSPCommonTable({
  functional_url,
  table_data_function_name,
  download_file_name,
  row_data_function_name,
  module_name,
  user_id,
  vendor_id,
  headerTitle,
  headerButton,
  columnTable,
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#FFFFFF",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const [modalOpen, setModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const handleClose = () => setModalOpen(false);

  const ExcelJS = require("exceljs");

  const downloadFile = async (id) => {
    let response = await post(
      base + functional_url + row_data_function_name,
      {
        log_id: id,
        module_name: module_name,
        user_id: user_id,
      },
      true,
      false
    );
    if (response.data !== null) {
      let data = response.data.body.message;
      const workbook = new ExcelJS.Workbook();
      const headers = Object.keys(data[0]);
      const worksheet = workbook.addWorksheet("data");
      const firstRow = worksheet.getRow(1);
      for (let i = 1; i <= headers.length; i++) {
        const cell = firstRow.getCell(i);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFA500" },
        };
      }
      worksheet.columns = headers.map((header) => ({ header, key: header }));
      data.forEach((dataRow) => {
        worksheet.addRow(dataRow);
      });
      worksheet.columns.forEach((column) => {
        column.width = 25;
      });
      workbook.xlsx.writeBuffer().then((buffer) => {
        const data = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(data, download_file_name + ".xlsx");
      });
    } else {
      setMessage("No data provided to download the file");
      setModalOpen(true);
    }
  };

  const columns = [
    { field: "id", headerName: "Sr.no", flex: 0.4 },
    {
      field: "file_name",
      headerName: "Files Name",
      flex: 1.5,
      wrapText: true,
      align: "left",
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    { field: "create_date", headerName: "Date", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      cellClassName: (params) => {
        if (params.value == null) {
          return "";
        }

        return clsx("super-app", {
          positive: params.value === "Success",
          negative: params.value === "Error",
          partial: params.value === "Partial Success",
        });
      },
    },
    {
      field: "count",
      headerName: (
        <div style={{ fontSize: "14px", lineHeight: "1.2" }}>
          <div>No of records </div>
          <div>processed</div>
        </div>
      ),
      flex: 1,
      wrapText: true,
      align: "left",
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
    },
    {
      field: "progress",
      headerName: "Progress",
      flex: 1,
      wrapText: true,
      align: "left",
      renderCell: (params) => {
        return <HoverCell value={params.value} />;
      },
      cellClassName: (params) => {
        if (params.value == null) {
          return "";
        }

        return clsx("super-app", {
          progressdata: params.value === "Customer Order Created",
          progressdatafail: params.value === "Customer Order Creation Failed",
        });
      },
    },
    {
      field: "log_id",
      headerName: "Process Logs",
      type: "number",
      flex: 1,
      renderCell: (params) => (
        <IconButton
          aria-label="Download"
          onClick={() => downloadFile(params.row.log_id)}
        >
          <Download color="primary" />
        </IconButton>
      ),
    },
  ];

  const [rows, setRows] = useState([]);
  const rowFetch = async () => {
    let response = await post(
      base + functional_url + table_data_function_name,
      { module_name: module_name, user_id: Number(user_id) },
      true,
      table_data_function_name === "/vendor_invoices" ? false : true
    );
    let responseData;
    if (table_data_function_name === "/vendor_invoices") {
      responseData = response?.data;
    } else {
      responseData = response?.message;
    }
    if (responseData?.length) {
      const rowsData = responseData?.map((row, index) => ({
        ...row,
        id: index + 1,
      }));
      setRows(rowsData);
    } else {
      setMessage("No Rows");
      setModalOpen(true);
    }
  };
  useEffect(() => {
    rowFetch();
  }, []);

  const HoverCell = ({ value }) => {
    return (
      <Tooltip title={value}>
        <div style={{ whiteSpace: "normal", textAlign: "start" }}>{value}</div>
      </Tooltip>
    );
  };

  return (
    <>
      <Card
        sx={{
          backgroundColor: "#EEF2F7",
          padding: "1.3rem",
          width: "inherit",
        }}
      >
        <CardHeader
          title={headerTitle || "Uploaded Files"}
          p={2}
          sx={{
            backgroundColor: "#F8F8F9",
            fontWeight: "700",
            borderTopRightRadius: "5px",
            borderTopLeftRadius: "5px",
          }}
          titleTypographyProps={{
            sx: {
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "16px",
              color: "#0160F1",
            },
          }}
          action={
            <>
              <Button onClick={() => window.location.reload()}>
                Refresh Page
              </Button>
            </>
          }
        />
        <Divider />
        <CardContent
          sx={{
            backgroundColor: "#FFFFFF",
            borderBottomRightRadius: "5px",
            borderBottomLeftRadius: "5px",
          }}
        >
          <Box
            sx={{
              height: 600,
              width: "100%",
              "& .super-app.positive": {
                color: "rgb(4,171,105)",

                fontWeight: "600",
              },
              "& .super-app.negative": {
                color: "rgb(234,39,21)",

                fontWeight: "600",
              },
              "& .super-app.partial": {
                color: "rgb(244,161,0)",

                fontWeight: "600",
              },
              "& .super-app.progressdata": {
                color: "rgb(4,171,105)",

                fontWeight: "600",
              },
              "& .super-app.progressdatafail": {
                color: "rgb(234,39,21)",

                fontWeight: "600",
              },

              "& .super-app.processing": {
                color: "rgb(104,112,122)",

                fontWeight: "600",
              },
              "& .super-app.pending": {
                color: "rgb(3,95,240)",

                fontWeight: "600",
              },
            }}
          >
            <DataGrid
              disableColumnMenu={true}
              rowHeight={60}
              showCellRightBorder={true}
              sx={{
                ".MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold !important",
                },
                overflowX: "scroll",
              }}
              rows={rows}
              columns={columnTable || columns}
              rowsPerPageOptions={[10]}
              pageSize={10}
              getRowId={(row) => row.id}
              components={{
                Toolbar: GridToolbar,
              }}
              componentsProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        </CardContent>
      </Card>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {message}
          </Typography>
        </Box>
      </Modal>
    </>
  );
}
